let React = require("react");
let UnitConversions = require("../../cio-config/unitConversions.js");
let MetaProperties = require("../../cio-config/metaProperties.js");

class PackageMetaData extends React.Component {
    convertToMM(value){ 
        if(!value){ return false };    
        return `${UnitConversions.Micrometers.toMillimeters(value)} mm`; 
    }

    render() {
        const naString = "n/a";
        const {pins, pitch, body_length, body_width, height, lead_span, lead_span2, pitch2, ipc_family, ipc_name, jedec_family, jedec_variant, mounting_type} = this.props.data;
        const ipcFamily = MetaProperties.getEnumFromNumber("package", "ipcFamily", ipc_family);
        const mountingType = MetaProperties.getEnumFromNumber("package", "mountingType", mounting_type);

        return (
            <table>
                <tbody>
                    <tr>
                        <td><span className="name">IPC Family:</span></td>
                        <td>{ipcFamily && ipcFamily.key || naString}</td>
                    </tr>

                    <tr>
                        <td><span className="name">IPC Name:</span></td>
                        <td>{ipc_name || naString}</td>
                    </tr>

                    <tr>
                        <td><span className="name">JEDEC Family:</span></td>
                        <td>{jedec_family || naString}</td>
                    </tr>

                    <tr>
                        <td><span className="name">JEDEC Variant:</span></td>
                        <td>{jedec_variant || naString}</td>
                    </tr>

                    <tr>
                        <td><span className="name">Pins: </span></td>
                        <td>{pins || naString}</td>
                    </tr>

                    <tr>
                        <td><span className="name">Pitch: </span></td>
                        <td>{this.convertToMM(pitch) || naString}</td>
                    </tr>

                    <tr>
                        <td><span className="name">Pitch2: </span></td>
                        <td>{this.convertToMM(pitch2) || naString}</td>
                    </tr>

                    <tr>
                        <td><span className="name">Lead Span: </span></td>
                        <td>{this.convertToMM(lead_span) || naString}</td>
                    </tr>

                    <tr>
                        <td><span className="name">Lead Span2: </span></td>
                        <td>{this.convertToMM(lead_span2) || naString}</td>
                    </tr>

                    <tr>
                        <td><span className="name">Body Length: </span></td>
                        <td>{this.convertToMM(body_length) || naString}</td>
                    </tr>

                    <tr>
                        <td><span className="name">Body Width: </span></td>
                        <td>{this.convertToMM(body_width) || naString}</td>
                    </tr>

                    <tr>
                        <td><span className="name">Height: </span></td>
                        <td>{this.convertToMM(height) || naString}</td>
                    </tr>

                    <tr>
                        <td><span className="name">Mounting Type: </span></td>
                        <td>{mountingType && mountingType.key || naString}</td>
                    </tr>
                </tbody>
            </table>
        );
    }
}

module.exports = PackageMetaData;